import Alpine from "alpinejs";
import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

Alpine.data("ImageGridAnimationTeam", () => ({
    /**
     * @param options
     * @returns Splide.defaults
     */
    getOptions(options) {
        return {
            type: "loop",
            drag: "free",
            arrows: false,
            focus: "center",
            perPage: 1,
            gap: 8,
            pagination: false,
            autoScroll: {
                speed: options.reverse === "true" ? -1 : 1,
            },
            mediaQuery: "min",
            breakpoints: {
                375: {
                    perPage: 2,
                },
                475: {
                    perPage: Math.max(2, Math.floor((475 / 1184) * 5)),
                },
                640: {
                    perPage: Math.max(3, Math.floor((640 / 1184) * 5)),
                },
                768: {
                    perPage: Math.max(3, Math.floor((768 / 1184) * 5)),
                    gap: 16,
                },
                860: {
                    perPage: Math.max(4, Math.floor((860 / 1184) * 5)),
                },
                1024: {
                    perPage: Math.max(4, Math.floor((1024 / 1184) * 5)),
                },
                1184: {
                    perPage: 5,
                },
            },
        };
    },
    slider: {
        ["x-init"]() {
            this.$nextTick(() => {
                this.$el
                    .querySelector(".splide__list")
                    .replaceChildren(
                        ...[...this.$el.querySelector(".splide__list").children].sort(() => Math.random() - 0.5)
                    );
                new Splide(this.$el, this.getOptions(this.$el.dataset)).mount({ AutoScroll });
            });
        },
    },
}));
